
<div class="d-flex flex-column flex-xl-row gap-4">
    <div class="col-12 col-xl-6">
        <form class="k-form k-form-md p-4" [formGroup]="form">
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="subject" class="col-form-label">{{ 'notification.subject' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="subject" formControlName="subject" class="form-control" [placeholder]="'notification.subject' | translate" />
                    <app-field-error-message controlName="subject"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="message" class="col-form-label">{{ 'notification.message' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <textarea type="text" id="message" formControlName="message" class="form-control" rows="5" [placeholder]="'notification.message' | translate"></textarea>
                    <app-field-error-message controlName="message" [maxLength]="4000"></app-field-error-message>
                </div>
            </div>

            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="notificationTypeList" class="col-form-label">{{ 'notification.notification_type_list' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <ng-multiselect-dropdown formControlName="notificationTypeList" id="notificationTypeList" [placeholder]="'common.please_select' | translate" [settings]="dropdownSettings" [data]="notificationTypeList"> </ng-multiselect-dropdown>
                    <app-field-error-message controlName="notificationTypeList"></app-field-error-message>
                </div>
            </div>

            <div class="mb-3 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="actionDeepLink" class="col-form-label">{{ 'notification.deeplink_title' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <div class="mb-2">
                        <label for="deeplinkSelect" class="form-label">{{ 'common.type' | translate }}</label>
                        <select id="deeplinkSelect" class="form-select" (change)="onSelectChange($event)">
                            <option value="" selected>{{ 'notification.deeplink_type_website' | translate }}</option>
                            <option *ngFor="let item of supportedPageTypeList">{{ item.text }}</option>
                        </select>
                    </div>
                    <div class="mb-2">
                        <label for="actionDeepLink" class="form-label">Link</label>
                        <input type="text" id="actionDeepLink" formControlName="actionDeepLink" class="form-control" [placeholder]="'notification.deeplink_title' | translate" />
                    </div>
                    <small class="text-muted d-block mt-2">
                        <ul class="mb-0 ps-3">
                            <li>{{ 'notification.deeplink_details_1' | translate }}</li>
                            <li>{{ 'notification.deeplink_details_2' | translate }}</li>
                            <li>
                                {{ 'notification.deeplink_details_3' | translate }}
                                <ul class="mt-1">
                                    <li class="text-monospace">{{ mauiAppName }}shop-page</li>
                                    <li class="text-monospace">{{ mauiAppName }}coupon-detail-page?id=1 ({{ 'notification.deeplink_details_4' | translate }})</li>
                                </ul>
                            </li>
                        </ul>
                    </small>
                    <app-field-error-message controlName="actionDeepLink"></app-field-error-message>
                </div>
            </div>
        </form>
    </div>

    <div class="col-12 col-xl-6">
        <app-vestra-user-select [title]="'notification.provider_list'" [vestraUserSelectType]="vestraUserSelectType" (selectedUserIds)="changeSelectedUserIds($event)"></app-vestra-user-select>
    </div>
</div>

<div class="d-flex flex-wrap justify-content-between align-items-center gap-3 px-4 mt-4 mb-5">
    <button id="promo-send" type="submit" [appClickWait] class="btn btn-secondary flex-grow-1 flex-md-grow-0" (click)="onSendNotification(2)">
        {{ 'notification.message_send_to_everyone' | translate }}
    </button>

    <button id="promo-send-selected" type="submit" [appClickWait] class="btn btn-primary flex-grow-1 flex-md-grow-0" (click)="onSendNotification(1)">
        {{ 'notification.message_send_to_selected' | translate }}
    </button>
</div>
